/**
 * LYMPHA FLOW DIRECT CHECKOUT & COMPLETE INTERACTIVE SUITE
 * 
 * Configured with Direct-to-Checkout Funnel Flow:
 * - "Add to Cart" / "Claim Offer" / Sticky ATC -> Redirects DIRECTLY to Checkout (/checkout)
 * - Header Cart Icon -> Opens Cart Drawer with current items / empty state
 * - Bundle Selection -> Updates selected variant, prices, and direct checkout link
 * - Subscribe & Save (-15%) -> Live discount recalculation
 * - Image Gallery -> Swiper thumbnail switching & prev/next navigation
 * - FAQ Accordions -> Smooth slide expand / collapse
 * - Customer Reviews -> "Show More / Afficher Moins" toggle
 * - Announcement Bar -> Live ticking countdown timer
 * - Login Modal -> Interactive Customer Login / Account Popup
 */

(function() {
  'use strict';

  const STATE = {
    currentVariantId: '46435081388089', // Default: Buy 2 Get 1 Free
    isSubscription: false,
    tiers: {
      '46435081355321': { id: '46435081355321', name: '1 Flacon (1 x 59ml)', qty: 1, price: 35.95, subPrice: 26.96, compare: 35.95, frequency: 'Toutes les 4 semaines', benefits: ['✓ Livraison Rapide & Gratuite', '✓ Livraison toutes les 4 semaines', '✓ Modifiable ou annulable en 1 clic'] },
      '46435081388089': { id: '46435081388089', name: 'Achetez 2, Obtenez 1 GRATUIT (3 x 59ml)', qty: 1, price: 70.95, subPrice: 53.21, compare: 107.85, frequency: 'Toutes les 8 semaines', benefits: ['✓ Livraison Rapide & Gratuite', '✓ Livraison toutes les 8 semaines', '✓ Modifiable ou annulable en 1 clic'] },
      '46435081420857': { id: '46435081420857', name: 'Achetez 3, Obtenez 2 GRATUITS (5 x 59ml)', qty: 1, price: 105.95, subPrice: 79.46, compare: 179.75, frequency: 'Toutes les 12 semaines', benefits: ['✓ Livraison Rapide & Gratuite', '✓ Livraison toutes les 12 semaines', '✓ Modifiable ou annulable en 1 clic'] }
    },
    items: []
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  function initAll() {
    injectModalsAndDrawers();
    initDirectCheckoutATC();
    initMobileDrawer();
    initCartDrawer();
    initLoginModal();
    initPDPBundles();
    initPDPGallery();
    initFAQAccordions();
    initReviewsShowMore();
    initCountdownTimer();
    initFooterNewsletter();
    initStickyCTA();
    initSmoothScrolling();
  }

  /* ==========================================================================
     1. DIRECT CHECKOUT ON ADD TO CART / CLAIM OFFER
     ========================================================================== */
  function initDirectCheckoutATC() {
    document.addEventListener('click', function(e) {
      const atcBtn = e.target.closest('.lw-pdp__atc, button[name="add"], #ly-atc-btn, #ly-sticky-atc-btn, .ly-sticky-btn');
      if (atcBtn) {
        e.preventDefault();
        redirectToCheckout(atcBtn);
      }
    });

    document.addEventListener('submit', function(e) {
      if (e.target.matches('form[action*="/cart/add"], form.shopify-product-form')) {
        e.preventDefault();
        const submitBtn = e.target.querySelector('button[type="submit"], .lw-pdp__atc');
        redirectToCheckout(submitBtn);
      }
    });
  }

  function redirectToCheckout(btn) {
    const form = document.querySelector('form[action*="/cart/add"], form.shopify-product-form');
    const variantInput = form ? form.querySelector('input[name="id"], [data-lw-variant-input]') : document.querySelector('input[name="id"]');
    const planInput = form ? form.querySelector('input[name="selling_plan"], [data-lw-plan-input]') : document.querySelector('input[name="selling_plan"]');
    
        // Dynamically retrieve variant ID from input or active offer button
    const activeOfferBtn = document.querySelector('.lw-pdp__offer[aria-checked="true"], .lw-pdp__offer.is-selected, .lw-pdp__offer[aria-pressed="true"]');
    const domVariantId = activeOfferBtn ? activeOfferBtn.getAttribute('data-variant-id') : null;
    const domPlanId = activeOfferBtn ? activeOfferBtn.getAttribute('data-plan-id') : null;
    const vId = (variantInput && variantInput.value) ? variantInput.value : (domVariantId || STATE.currentVariantId);
    
    let sellingPlan = '';
    if (STATE.isSubscription) {
      // 1. Dynamic lookup from real Shopify variant selling plan allocations
      if (window._LY_SELLING_PLANS_DATA && window._LY_SELLING_PLANS_DATA.length > 0) {
        const varData = window._LY_SELLING_PLANS_DATA.find(d => String(d.variantId) === String(vId));
        if (varData && varData.allocations && varData.allocations.length > 0) {
          const idx = activeOfferBtn ? Array.from(document.querySelectorAll('.lw-pdp__offer')).indexOf(activeOfferBtn) : 0;
          const targetAlloc = varData.allocations[idx] || varData.allocations[0];
          if (targetAlloc && targetAlloc.id) {
            sellingPlan = targetAlloc.id;
          }
        }
      }

      // 2. If not found in allocations data, check inputs and DOM attributes
      if (!sellingPlan && planInput && !planInput.disabled && planInput.value) {
        sellingPlan = planInput.value;
      } else if (!sellingPlan && domPlanId && String(domPlanId).trim() !== '') {
        sellingPlan = domPlanId;
      } else if (!sellingPlan && window._LY_STORE_VARIANTS) {
        const idx = activeOfferBtn ? Array.from(document.querySelectorAll('.lw-pdp__offer')).indexOf(activeOfferBtn) : 1;
        sellingPlan = (idx === 0 ? window._LY_STORE_VARIANTS.plan1 : (idx === 2 ? window._LY_STORE_VARIANTS.plan3 : window._LY_STORE_VARIANTS.plan2));
      }
    }

    if (btn) {
      btn.innerHTML = `
        <span style="display:inline-flex; align-items:center; gap:8px;">
          <svg style="animation: spin 0.8s linear infinite; width:18px; height:18px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-opacity="0.25"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor"></path></svg>
          Redirection vers le paiement sécurisé...
        </span>
      `;
      btn.setAttribute('disabled', 'true');
    }

    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    if (isLocal) {
      setTimeout(() => {
        alert(`[Environnement de Test Local] : \n\nRedirection Checkout Shopify avec la variante ID: ${vId}`);
        if (btn) btn.removeAttribute('disabled');
      }, 400);
    } else {
      // Shopify Online Store: Add item to cart via Shopify API and redirect straight to checkout
      const hasValidPlan = sellingPlan && String(sellingPlan).trim() !== '' && String(sellingPlan) !== '0' && String(sellingPlan) !== 'null' && String(sellingPlan) !== 'undefined';
      const itemsToAdd = [{
        id: Number(vId) || vId,
        quantity: 1,
        ...(hasValidPlan ? { selling_plan: Number(sellingPlan) || sellingPlan } : {})
      }];

      const hasGift = activeOfferBtn && (activeOfferBtn.getAttribute('data-gift') === 'true' || activeOfferBtn.getAttribute('data-lw-offer') === '2');
      const giftVarId = (activeOfferBtn && activeOfferBtn.getAttribute('data-gift-id')) || window._LY_GIFT_VARIANT_ID;
      if (hasGift && giftVarId && String(giftVarId).trim() !== '' && String(giftVarId) !== '0') {
        itemsToAdd.push({
          id: Number(giftVarId) || giftVarId,
          quantity: 1,
          properties: {
            '_Cadeau': 'Brosse Offerte avec le Pack 5 Flacons'
          }
        });
      }

      const payload = {
        items: itemsToAdd
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => { throw err; });
        }
        return res.json();
      })
      .then(data => {
        const giftCode = window._LY_GIFT_DISCOUNT_CODE;
        if (hasGift && giftCode && String(giftCode).trim() !== '') {
          window.location.href = `/checkout?discount=${encodeURIComponent(giftCode)}`;
        } else {
          window.location.href = '/checkout';
        }
      })
      .catch(err => {
        console.error("Shopify Cart Add Error:", err);
        const description = (err && (err.description || err.message)) ? (err.description || err.message) : "";
        if (description.includes("forfait de vente") || description.includes("selling plan") || description.includes("selling_plan")) {
          alert("Abonnement Shopify : \n\n" + description + "\n\n💡 Assurez-vous dans votre application d'abonnement (ex: Shopify Subscriptions) que ce forfait a bien été associé à toutes les variantes du produit Lympha Flow.");
        } else {
          alert("Erreur lors de l'ajout au panier Shopify : \n\n" + (description || "Produit introuvable ou en rupture de stock.") + "\n\n(Assurez-vous que votre produit est actif et avec du stock dans votre Admin Shopify > Produits).");
        }
        if (btn) {
          btn.removeAttribute('disabled');
          btn.innerHTML = `<span>Ajouter au Panier &bull; ${STATE.isSubscription ? (prices[activeIndex] || prices[1]).sub : (prices[activeIndex] || prices[1]).one}</span>`;
        }
      });
    }
  }

  /* ==========================================================================
     2. DYNAMIC BUY BOX (Single Source of Truth)
     ========================================================================== */
  function initPDPBundles() {
    const root = document.getElementById('lw-pdp-template--20177151033483__lymphoria_home_buy_box_wbz_RwVcQY') || document;
    const offerBtns = Array.from(root.querySelectorAll('.lw-pdp__offer, [data-lw-offer]'));
    const planBtns = Array.from(root.querySelectorAll('.lw-pdp__plan, [data-lw-plan]'));
    const atcBtn = root.querySelector('.lw-pdp__atc, [data-lw-atc]');
    const variantInput = root.querySelector('input[name="id"], [data-lw-variant-input]');
    const planInput = root.querySelector('input[name="selling_plan"], [data-lw-plan-input]');
    const subPriceEl = root.querySelector('[data-lw-sub-price]');
    const onePriceEl = root.querySelector('[data-lw-one-price]');
    const benefitsWrap = root.querySelector('[data-lw-benefits], .lw-pdp__benefits');

    let activeIndex = 1; // Default to Buy 2, Get 1 Free

    const prices = [
      { name: '1 Flacon', qty: 1, one: '€35,95', sub: '€26,96', compare: '', subCompare: '€35,95', freq: 'Toutes les 4 semaines', benefits: ['✓ Livraison Rapide & Gratuite', '✓ Livraison toutes les 4 semaines', '✓ Modifiable ou annulable en 1 clic'] },
      { name: 'Achetez 2, Obtenez 1 GRATUIT', qty: 3, one: '€70,95', sub: '€53,21', compare: '', subCompare: '€70,95', freq: 'Toutes les 8 semaines', benefits: ['✓ Livraison Rapide & Gratuite', '✓ Livraison toutes les 8 semaines', '✓ Modifiable ou annulable en 1 clic'] },
      { name: 'Achetez 3, Obtenez 2 GRATUITS', qty: 5, one: '€105,95', sub: '€79,46', compare: '', subCompare: '€105,95', freq: 'Toutes les 12 semaines', benefits: ['✓ Livraison Rapide & Gratuite', '✓ Livraison toutes les 12 semaines', '✓ Modifiable ou annulable en 1 clic'] }
    ];

    function renderState() {
      const p = prices[activeIndex] || prices[1];
      const isSub = STATE.isSubscription;

      // 1. Update Offer Cards
      offerBtns.forEach((btn, idx) => {
        const item = prices[idx] || prices[0];
        const isCurrent = idx === activeIndex;
        btn.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
        btn.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
        btn.classList.toggle('is-active', isCurrent);
        btn.classList.toggle('is-selected', isCurrent);

        const priceEl = btn.querySelector('.lw-pdp__offer-price, [data-lw-offer-price]');
        const compareEl = btn.querySelector('.lw-pdp__offer-compare, [data-lw-offer-compare]');
        const domOne = btn.getAttribute('data-price') || item.one;
        const domSub = btn.getAttribute('data-plan-price') || item.sub;
        const domComp = btn.getAttribute('data-compare') || item.compare;
        const domSubComp = btn.getAttribute('data-plan-compare') || item.subCompare;

        if (priceEl) priceEl.textContent = isSub ? domSub : domOne;
        if (compareEl) {
          const compVal = isSub ? domSubComp : domComp;
          compareEl.textContent = compVal || '';
          compareEl.style.display = compVal ? '' : 'none';
        }
      });

      // 2. Update Plan Cards
      planBtns.forEach(btn => {
        const type = btn.getAttribute('data-lw-plan') || (btn.classList.contains('lw-pdp__plan--sub') ? 'subscribe' : 'onetime');
        const isPlanActive = isSub ? (type === 'subscribe') : (type === 'onetime');
        btn.setAttribute('aria-checked', isPlanActive ? 'true' : 'false');
        btn.setAttribute('aria-pressed', isPlanActive ? 'true' : 'false');
        btn.classList.toggle('is-active', isPlanActive);
        btn.classList.toggle('is-selected', isPlanActive);
      });

      const currentBtn = offerBtns[activeIndex];
      const currentOne = (currentBtn && currentBtn.getAttribute('data-price')) || p.one;
      const currentSub = (currentBtn && currentBtn.getAttribute('data-plan-price')) || p.sub;

      if (subPriceEl) subPriceEl.textContent = currentSub;
      if (onePriceEl) onePriceEl.textContent = currentOne;

      // 3. Update Benefits
      if (benefitsWrap) {
        injectBenefitGiftStyles();
        const domBenefitsRaw = currentBtn ? currentBtn.getAttribute('data-benefits') : null;
        const benefitsList = domBenefitsRaw ? domBenefitsRaw.split('~|~') : p.benefits;
        if (benefitsList && benefitsList.length > 0) {
          benefitsWrap.innerHTML = benefitsList.map(b => `<span class="lw-pdp__benefit">${b}</span>`).join('');
        }
      }

      // 4. Update Variant & Plan Inputs
      if (currentBtn) {
        const vId = currentBtn.getAttribute('data-variant-id');
        const planId = currentBtn.getAttribute('data-plan-id');
        if (variantInput && vId) variantInput.value = vId;
        if (planInput) {
          planInput.value = isSub ? (planId || '') : '';
          planInput.disabled = !planInput.value;
        }
      }

      // 5. Update Main Add to Cart Button
      const displayPrice = isSub ? currentSub : currentOne;
      if (atcBtn) {
        atcBtn.innerHTML = `Ajouter au Panier &bull; ${displayPrice}`;
      }

      // 6. Update Sticky Bar
      const stickName = document.getElementById('ly-sticky-tier-name');
      const stickPrice = document.getElementById('ly-sticky-tier-price');
      const stickThumb = document.querySelector('.ly-sticky-thumb, .ly-sticky-bar__img');
      if (stickName) stickName.textContent = (currentBtn && currentBtn.querySelector('.lw-pdp__offer-name') ? currentBtn.querySelector('.lw-pdp__offer-name').textContent.trim() : p.name);
      if (stickPrice) stickPrice.textContent = displayPrice;
      if (stickThumb && currentBtn) {
        const offerImg = currentBtn.querySelector('img');
        if (offerImg && offerImg.src) {
          stickThumb.src = offerImg.src;
        }
      }

    }

    offerBtns.forEach((btn, idx) => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        activeIndex = idx;
        renderState();
      });
    });

    planBtns.forEach(p => {
      p.addEventListener('click', function(e) {
        e.preventDefault();
        const type = p.getAttribute('data-lw-plan') || (p.classList.contains('lw-pdp__plan--sub') ? 'subscribe' : 'onetime');
        STATE.isSubscription = (type === 'subscribe');
        renderState();
      });
    });

    // Initial render
    renderState();
  }

  function injectBenefitGiftStyles() {
    if (document.getElementById('lw-benefit-gift-styles')) return;
    const style = document.createElement('style');
    style.id = 'lw-benefit-gift-styles';
    style.textContent = `
      .lw-benefit-gift-pill {
        display: flex !important;
        align-items: center !important;
        gap: 10px !important;
        margin-top: 6px !important;
        padding: 6px 10px !important;
        background: #ffffff !important;
        border: 1.5px solid #47c08e !important;
        border-radius: 9px !important;
        box-shadow: 0 2px 8px rgba(21, 75, 50, 0.12) !important;
      }
      .lw-benefit-gift-img-wrap {
        position: relative !important;
        width: 44px !important;
        height: 44px !important;
        flex: 0 0 44px !important;
        border-radius: 7px !important;
        border: 1px solid #d5e9dc !important;
        background: #fcf9f2 !important;
        overflow: hidden !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
      .lw-benefit-gift-img-wrap img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        display: block !important;
      }
      .lw-benefit-gift-chip {
        position: absolute !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        background: #154b32 !important;
        color: #ffffff !important;
        font-size: 7px !important;
        font-weight: 800 !important;
        text-align: center !important;
        line-height: 1.2 !important;
        padding: 1px 0 !important;
        letter-spacing: 0.3px !important;
        text-transform: uppercase !important;
      }
      .lw-benefit-gift-text {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 1px !important;
        text-align: left !important;
      }
      .lw-benefit-gift-text strong {
        font-size: 11.5px !important;
        font-weight: 700 !important;
        color: #12412b !important;
        line-height: 1.25 !important;
      }
      .lw-benefit-gift-text span {
        font-size: 10px !important;
        color: #1e6443 !important;
        font-weight: 600 !important;
        line-height: 1.2 !important;
      }

      /* Bundle 3 with bottom borders removed */
      .lw-pdp__offer--has-addon {
        border-bottom: none !important;
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
        box-shadow: none !important;
      }
      .lw-pdp__offer--has-addon[aria-checked='true'] {
        border-color: #154b32 !important;
        border-width: 2px !important;
        border-bottom: none !important;
      }
      .swatch-product-free--addon.add-border {
        position: absolute !important;
        top: 100% !important;
        left: 0 !important;
        right: 0 !important;
        width: 100% !important;
        min-height: 44px !important;
        background: #154b32 !important;
        border: 1.5px solid var(--lw-card-border, #d4dfd8) !important;
        border-top: none !important;
        border-bottom-left-radius: var(--lw-radius, 8px) !important;
        border-bottom-right-radius: var(--lw-radius, 8px) !important;
        padding: 4px 8px !important;
        box-shadow: 2px 4px 4px rgba(0, 0, 0, .08) !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
        z-index: 2 !important;
        overflow: hidden !important;
        transition: background-color 0.2s ease, border-color 0.2s ease !important;
      }
      .lw-pdp__offer-col:has([aria-checked='true']) .swatch-product-free--addon.add-border,
      .lw-pdp__offer--has-addon[aria-checked='true'] + .swatch-product-free--addon.add-border {
        border-color: #154b32 !important;
        border-width: 2px !important;
        border-top: none !important;
        background: #12412b !important;
      }
      .image-and-text-container {
        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        gap: 6px !important;
        width: 100% !important;
        height: 100% !important;
        flex-wrap: nowrap !important;
      }
      .image-and-text-container .image {
        width: 38px !important;
        height: 38px !important;
        flex: 0 0 38px !important;
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 !important;
        overflow: visible !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
      .image-and-text-container .image img {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
        display: block !important;
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2)) !important;
      }
      .image-and-text-container p,
      .image-and-text-container .text p {
        margin: 0 !important;
        color: #ffffff !important;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
        font-size: clamp(9px, 1vw, 13.5px);
        font-weight: 500 !important;
        line-height: 1.1 !important;
        letter-spacing: -0.1px !important;
        text-align: left !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
      }
      .image-and-text-container strong,
      .image-and-text-container .text strong {
        font-weight: 800 !important;
        color: #ffffff !important;
        display: inline !important;
        white-space: nowrap !important;
      }
      @media screen and (max-width: 640px) {
        .swatch-product-free--addon.add-border {
          min-height: 52px !important;
          padding: 4px 4px !important;
        }
        .image-and-text-container {
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          text-align: center !important;
          gap: 2px !important;
        }
        .image-and-text-container .image {
          width: 28px !important;
          height: 28px !important;
          flex: 0 0 28px !important;
        }
        .image-and-text-container p,
        .image-and-text-container .text p {
          text-align: center !important;
          font-size: clamp(8.5px, 2.4vw, 11px);
          white-space: nowrap !important;
          width: 100% !important;
        }
      }
    `;
    document.head.appendChild(style);

    function fitGiftText() {
      var containers = document.querySelectorAll('.image-and-text-container');
      containers.forEach(function(container) {
        var p = container.querySelector('p');
        if (!p) return;
        var img = container.querySelector('.image');
        var containerWidth = container.clientWidth;
        if (!containerWidth) return;

        var isNarrow = containerWidth < 135 || window.innerWidth <= 640;

        if (isNarrow) {
          container.style.flexDirection = 'column';
          container.style.alignItems = 'center';
          container.style.justifyContent = 'center';
          container.style.gap = '2px';
          container.style.textAlign = 'center';
          if (img) {
            img.style.width = '28px';
            img.style.height = '28px';
            img.style.flex = '0 0 28px';
          }
          var addon = container.closest('.swatch-product-free--addon');
          if (addon) addon.style.minHeight = '52px';

          var availableWidth = containerWidth - 8;
          if (availableWidth <= 20) return;

          p.style.whiteSpace = 'nowrap';
          p.style.display = 'block';
          p.style.textAlign = 'center';
          p.style.width = '100%';

          var low = 8;
          var high = 13.5;
          var best = low;
          for (var i = 0; i < 10; i++) {
            var mid = (low + high) / 2;
            p.style.fontSize = mid + 'px';
            if (p.scrollWidth <= availableWidth) {
              best = mid;
              low = mid + 0.15;
            } else {
              high = mid - 0.15;
            }
          }
          p.style.fontSize = (Math.floor(best * 10) / 10) + 'px';
        } else {
          container.style.flexDirection = 'row';
          container.style.alignItems = 'center';
          container.style.justifyContent = 'flex-start';
          container.style.gap = '6px';
          container.style.textAlign = 'left';
          if (img) {
            img.style.width = '38px';
            img.style.height = '38px';
            img.style.flex = '0 0 38px';
          }
          var addon = container.closest('.swatch-product-free--addon');
          if (addon) addon.style.minHeight = '44px';

          var imgWidth = img ? (img.offsetWidth || 38) : 38;
          var availableWidth = containerWidth - imgWidth - 6 - 4;
          if (availableWidth <= 20) return;

          p.style.whiteSpace = 'nowrap';
          p.style.display = 'inline-block';
          p.style.textAlign = 'left';
          p.style.width = 'auto';

          var low = 8;
          var high = 16;
          var best = low;
          for (var i = 0; i < 10; i++) {
            var mid = (low + high) / 2;
            p.style.fontSize = mid + 'px';
            if (p.scrollWidth <= availableWidth) {
              best = mid;
              low = mid + 0.15;
            } else {
              high = mid - 0.15;
            }
          }
          p.style.fontSize = (Math.floor(best * 10) / 10) + 'px';
        }
      });
    }

    fitGiftText();
    window.addEventListener('resize', fitGiftText);
    window.addEventListener('load', fitGiftText);
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(function() {
        fitGiftText();
      });
      var el = document.querySelector('.swatch-product-free--addon');
      if (el) observer.observe(el);
      var offers = document.querySelector('.lw-pdp__offers');
      if (offers) observer.observe(offers);
    }
  }

    /* ==========================================================================
     3. AUTHENTIC LYMPHA FLOW CART DRAWER (LIVE SHOPIFY AJAX SYNC)
     ========================================================================== */
  function fetchShopifyCart(callback) {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (isLocal) {
      renderCart();
      if (typeof callback === 'function') callback();
      return;
    }
    fetch('/cart.js', { cache: 'no-store' })
      .then(res => res.json())
      .then(cart => {
        if (cart && Array.isArray(cart.items)) {
          STATE.items = cart.items.map(item => {
            let img = item.image;
            if (!img && item.featured_image) {
              img = typeof item.featured_image === 'string' ? item.featured_image : item.featured_image.url;
            }
            if (!img) img = 'https://2kvfzb-km.myshopify.com/cdn/shop/files/pdp_images_996f02db-93d9-4992-ad74-1f082727b240.webp';

            return {
              id: String(item.variant_id || item.id),
              key: item.key,
              name: item.product_title || item.title || 'Lympha Wave®',
              variant_title: item.variant_title || '',
              price: (item.price || 0) / 100,
              compare_price: ((item.original_price && item.original_price > item.price) ? item.original_price : item.price) / 100,
              quantity: item.quantity || 1,
              image: img,
              properties: item.properties || {}
            };
          });
        } else {
          STATE.items = [];
        }
        renderCart();
        if (typeof callback === 'function') callback();
      })
      .catch(err => {
        console.error("Cart fetch error:", err);
        renderCart();
        if (typeof callback === 'function') callback();
      });
  }

  function changeItemQty(keyOrId, newQty) {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (isLocal) {
      const item = STATE.items.find(i => i.id === keyOrId || i.key === keyOrId);
      if (item) {
        item.quantity = newQty;
        if (item.quantity <= 0) STATE.items = STATE.items.filter(i => (i.id !== keyOrId && i.key !== keyOrId));
      }
      renderCart();
      return;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: keyOrId, quantity: newQty })
    })
    .then(res => res.json())
    .then(() => {
      fetchShopifyCart();
    })
    .catch(() => fetchShopifyCart());
  }

    function openCart() {
    const drawer = document.getElementById('cart-drawer');
    let overlay = document.querySelector('.custom_overlay2') || document.getElementById('cart-drawer-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'custom_overlay2';
      overlay.id = 'cart-drawer-overlay';
      document.body.appendChild(overlay);
    }
    if (drawer) {
      drawer.classList.add('open');
      drawer.classList.remove('is-closed');
      drawer.style.right = '0';
      drawer.style.display = 'block';
    }
    overlay.classList.add('active');
    overlay.style.display = 'block';
    overlay.style.background = 'rgba(0, 0, 0, 0.45)';
    overlay.style.backdropFilter = 'blur(4px)';
    overlay.style.opacity = '1';
    overlay.style.visibility = 'visible';
    document.body.classList.add('overflow-hidden');
    fetchShopifyCart();
  }

  function closeCart() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.querySelector('.custom_overlay2') || document.getElementById('cart-drawer-overlay');
    if (drawer) {
      drawer.classList.remove('open');
      drawer.classList.add('is-closed');
      drawer.style.right = '-460px';
    }
    if (overlay) {
      overlay.classList.remove('active');
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      setTimeout(() => {
        if (!drawer || !drawer.classList.contains('open')) {
          overlay.style.display = 'none';
        }
      }, 300);
    }
    document.body.classList.remove('overflow-hidden');
  }

  window.openCart = openCart;
  window.closeCart = closeCart;

  function initCartDrawer() {
    // ESC key closes drawer
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeCart();
      }
    });

    document.addEventListener('click', function(e) {
      if (e.target.closest('#cart-toggle, .header_cart_toggle, .header_cart, a[href="/cart"], .cart_count_js')) {
        e.preventDefault();
        openCart();
      }
      if (e.target.closest('#cart-close, .cart-close, [data-cart-close], .cart_empty_button, #ly-continue-shopping, .close_cart_btn') || e.target.classList.contains('custom_overlay2') || e.target.id === 'cart-drawer-overlay') {
        e.preventDefault();
        closeCart();
      }
      
      // Quantity plus
      const plusBtn = e.target.closest('.cart_quantity_button.quantity_plus, .quantity_plus');
      if (plusBtn) {
        e.preventDefault();
        const flex = plusBtn.closest('.cart_item_single_flex');
        const key = flex ? (flex.getAttribute('data-item-key') || flex.getAttribute('data-variant-id')) : null;
        const item = STATE.items.find(i => i.key === key || i.id === key);
        if (item) changeItemQty(item.key || item.id, item.quantity + 1);
      }

      // Quantity minus
      const minusBtn = e.target.closest('.cart_quantity_button.quantity_minus, .quantity_minus');
      if (minusBtn) {
        e.preventDefault();
        const flex = minusBtn.closest('.cart_item_single_flex');
        const key = flex ? (flex.getAttribute('data-item-key') || flex.getAttribute('data-variant-id')) : null;
        const item = STATE.items.find(i => i.key === key || i.id === key);
        if (item) changeItemQty(item.key || item.id, item.quantity - 1);
      }

      // Remove item
      const removeBtn = e.target.closest('.cart_item_single_right_remove');
      if (removeBtn) {
        e.preventDefault();
        const flex = removeBtn.closest('.cart_item_single_flex');
        const key = flex ? (flex.getAttribute('data-item-key') || flex.getAttribute('data-variant-id')) : null;
        if (key) changeItemQty(key, 0);
      }

      // Checkout button
      if (e.target.closest('#ly-go-checkout, .checkout_button, .checkout_button_custom')) {
        e.preventDefault();
        const btn = e.target.closest('#ly-go-checkout, .checkout_button, .checkout_button_custom');
        btn.innerHTML = '<span>Redirection vers le paiement sécurisé...</span>';
        setTimeout(function() {
          window.location.href = '/checkout';
        }, 300);
      }
    });

    // Auto-fetch cart count on load
    fetchShopifyCart();
  }

  function renderCart() {
    const drawer = document.getElementById('cart-drawer');
    const content = document.getElementById('cart_drawer_content');
    if (!content) return;

    const totalCount = STATE.items.reduce((s, it) => s + it.quantity, 0);

    // Badges
    document.querySelectorAll('.cart_count_js, #ly-cart-count, .cart-count-bubble').forEach(b => {
      b.textContent = totalCount > 0 ? totalCount : '';
      b.style.display = totalCount > 0 ? 'inline-block' : 'none';
    });

    if (STATE.items.length === 0) {
      if (drawer) drawer.classList.add('is_empty');
      content.innerHTML = `
        <div class="cart-content">
          <div class="cart_empty_content">
            <div class="cart_empty_heading">Votre Panier est Vide</div>
            <div class="cart_empty_button" id="ly-continue-shopping">Continuer mes Achats</div>
          </div>
        </div>
      `;
      return;
    }

    if (drawer) drawer.classList.remove('is_empty');

    let subtotal = 0;
    let savings = 0;

    const bundle3VarId = window._LY_VAR_3_ID || (window._LY_STORE_VARIANTS && window._LY_STORE_VARIANTS.var3) || '46435081420857';
    const hasBundle3InCart = STATE.items.some(i => String(i.id) === String(bundle3VarId));

    const itemsHtml = STATE.items.map(item => {
      const isGift = hasBundle3InCart && (
        (item.properties && (item.properties['_Cadeau'] || item.properties['Cadeau'])) ||
        (window._LY_GIFT_VARIANT_ID && String(item.id) === String(window._LY_GIFT_VARIANT_ID))
      );

      const effectivePrice = isGift ? 0 : item.price;
      const sub = effectivePrice * item.quantity;
      const originalUnitPrice = item.price > 0 ? item.price : 19.95;
      const comp = (item.compare_price || originalUnitPrice) * item.quantity;

      subtotal += sub;
      if (comp > sub) savings += (comp - sub);

      const formattedSub = isGift ? 'GRATUIT' : `€${String(sub.toFixed(2)).replace('.', ',')}`;
      const formattedComp = String(comp.toFixed(2)).replace('.', ',');

      return `
        <div class="cart_item_single_flex" data-variant-id="${item.id}" data-item-key="${item.key || item.id}">
          <div class="cart_item_single_left">
            <img src="${item.image}" class="item_image" alt="${item.name}">
          </div>
          <div class="cart_item_single_right">
            <div class="cart_item_single_top_row">
              <div class="cart_item_single_title_wrap">
                <h4 class="cart_item_single_title">${item.name}</h4>
                ${isGift ? `<div class="cart_item_single_variant_tag" style="background:#154b32; color:#ffffff; font-weight:700; border-radius:3px; padding:1px 6px; display:inline-block; font-size:10px;">🎁 OFFERT AVEC LE BUNDLE</div>` : (item.variant_title ? `<div class="cart_item_single_variant_tag">${item.variant_title}</div>` : '')}
              </div>
              <div class="cart_item_single_prices">
                <span class="cart_item_single_price" style="${isGift ? 'color:#154b32; font-weight:800;' : ''}">${formattedSub}</span>
                ${(isGift || comp > sub) ? `<s class="cart_item_single_price_compare">€${formattedComp}</s>` : ''}
              </div>
            </div>
            <div class="cart_item_single_bottom_row">
              <div class="cart_quantity_wrapper">
                ${isGift ? `
                  <span style="font-size:12px; color:#154b32; font-weight:600; padding:4px 8px;">Qté: 1 (Offert)</span>
                ` : `
                  <button type="button" class="cart_quantity_button quantity_minus" aria-label="Decrease quantity">−</button>
                  <input type="text" class="fake_quantity_display" value="${item.quantity}" readonly>
                  <button type="button" class="cart_quantity_button quantity_plus" aria-label="Increase quantity">+</button>
                `}
              </div>
              <button type="button" class="cart_item_single_right_remove" aria-label="Remove item" title="Supprimer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#717171" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    const formattedSubtotal = String(subtotal.toFixed(2)).replace('.', ',');
    const formattedSavings = String(savings.toFixed(2)).replace('.', ',');

    content.innerHTML = `
      <div class="cart_content_fill">
        <div class="cart_heading_custom">
          <div class="cart_heading_title">Votre Panier (${totalCount})</div>
          <div class="cart_choice_badge">🌿 100% Végétal</div>
        </div>

        <div class="cart_free_shipping_box">
          <div class="cart_free_shipping_text">🎉 Félicitations ! Vous bénéficiez de la <strong>LIVRAISON GRATUITE !</strong></div>
          <div class="cart_free_shipping_bar">
            <div class="cart_free_shipping_fill" style="width: 100%;"></div>
          </div>
        </div>

        <div class="cart_middle_scroll">
          <div class="cart_items_wrapper">${itemsHtml}</div>
          <div class="cart_reviews_section">
            <div class="cart_reviews_title">Avis Client Vérifié</div>
            <div class="review_box_incart">
              <div class="review_stars_incart">★★★★★</div>
              <p class="review_text_incart">“C'est devenu mon rituel du matin : une pipette dans mon verre d'eau. La sensation de gonflement au niveau de mes chevilles et mes jambes a disparu !”</p>
              <div class="review_author_incart">— Maya K. <span class="verified_tag">✓ Acheteuse Vérifiée</span></div>
            </div>
          </div>
        </div>

        <div class="cart_footer_custom">
          <div class="cart_footer_subtotal_flex">
            <span class="cart_subtotal_label">Sous-total</span>
            <div class="cart_subtotal_values">
              ${savings > 0 ? `<span class="cart_savings_pill">Économie : €${formattedSavings}</span>` : ''}
              <span class="cart_subtotal_amount">€${formattedSubtotal}</span>
            </div>
          </div>
          <div class="cart_footer_btn_wrap">
            <button type="button" class="checkout_button_custom" id="ly-go-checkout">
              <span>COMMANDER MAINTENANT</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </div>
          <div class="cart_trust_footer_row">
            <span>🛡️ Garantie 60 Jours</span>
            <span>&bull;</span>
            <span>🔒 Paiement Sécurisé SSL</span>
          </div>
        </div>
      </div>
    `;
  }

  /* ==========================================================================
     4. LOGIN MODAL (Disabled to allow direct navigation to /account)
     ========================================================================== */
  function initLoginModal() {
    // Direct navigation to /account without modal popup
  }

  /* ==========================================================================
     5. MOBILE DRAWER
     ========================================================================== */
  function initMobileDrawer() {
    const drawer = document.getElementById('menu-drawer');
    const overlay = document.querySelector('.custom_overlay');

    function openMobileDrawer() {
      if (drawer) drawer.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }

    function closeMobileDrawer() {
      if (drawer) drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }

    document.addEventListener('click', function(e) {
      if (e.target.closest('#drawer-toggle, .drawer-button, .header_burger, .menu-drawer-toggle')) {
        e.preventDefault();
        openMobileDrawer();
      }
      if (e.target.closest('#drawer-close, .drawer-close') || (overlay && e.target === overlay)) {
        e.preventDefault();
        closeMobileDrawer();
      }
      const parentLink = e.target.closest('.drawer-menu-item.has-children > .parent-link');
      if (parentLink) {
        e.preventDefault();
        const sub = parentLink.nextElementSibling;
        if (sub) {
          sub.classList.toggle('open');
          parentLink.classList.toggle('active');
        }
      }
    });
  }

  /* ==========================================================================
     6. PDP GALLERY
     ========================================================================== */
  function initPDPGallery() {
    const thumbs = Array.from(document.querySelectorAll('.lw-pdp__thumb, [data-lw-thumb]'));
    const slides = Array.from(document.querySelectorAll('.lw-pdp__gallery-main .swiper-slide, .lw-pdp__slide, [data-lw-slide]'));
    let currentSlide = 0;

    function setSlide(idx) {
      if (slides.length === 0) return;
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      currentSlide = idx;

      thumbs.forEach((t, i) => {
        t.classList.toggle('swiper-slide-thumb-active', i === currentSlide);
        t.classList.toggle('is-active', i === currentSlide);
      });

      slides.forEach((s, i) => {
        s.style.display = (i === currentSlide ? 'block' : 'none');
        s.style.opacity = (i === currentSlide ? '1' : '0');
      });
    }

    window._setPDPSlide = setSlide;

    thumbs.forEach((t, i) => {
      t.addEventListener('click', function(e) {
        e.preventDefault();
        setSlide(i);
      });
    });

    const prev = document.querySelector('.lw-pdp__nav--prev, [data-lw-prev]');
    const next = document.querySelector('.lw-pdp__nav--next, [data-lw-next]');
    if (prev) prev.addEventListener('click', function(e) { e.preventDefault(); setSlide(currentSlide - 1); });
    if (next) next.addEventListener('click', function(e) { e.preventDefault(); setSlide(currentSlide + 1); });

    setSlide(0);
  }

  /* ==========================================================================
     7. FAQ ACCORDIONS
     ========================================================================== */
  function initFAQAccordions() {
    document.addEventListener('click', function(e) {
      const qBtn = e.target.closest('.lw-faq__q');
      if (qBtn) {
        e.preventDefault();
        const item = qBtn.closest('.lw-faq__item');
        if (!item) return;
        const isOpen = item.classList.contains('is-open');

        document.querySelectorAll('.lw-faq__item').forEach(it => {
          it.classList.remove('is-open');
          const p = it.querySelector('.lw-faq__panel');
          if (p) p.style.display = 'none';
        });

        if (!isOpen) {
          item.classList.add('is-open');
          const panel = item.querySelector('.lw-faq__panel');
          if (panel) panel.style.display = 'block';
        }
      }
    });

    const first = document.querySelector('.lw-faq__item');
    if (first) {
      first.classList.add('is-open');
      const p = first.querySelector('.lw-faq__panel');
      if (p) p.style.display = 'block';
    }
  }

  /* ==========================================================================
     8. CUSTOMER REVIEWS SHOW MORE
     ========================================================================== */
  function initReviewsShowMore() {
    document.addEventListener('click', function(e) {
      const toggle = e.target.closest('.routine-testimonials__toggle, #ly-show-more-reviews');
      if (toggle) {
        e.preventDefault();
        const hiddenCards = document.querySelectorAll('.routine-testimonials__item.is-hidden, .ly-review-hidden');
        let anyVisible = false;
        hiddenCards.forEach(c => {
          if (c.style.display === 'block') anyVisible = true;
        });

        hiddenCards.forEach(c => {
          c.style.display = anyVisible ? 'none' : 'block';
        });
        toggle.textContent = anyVisible ? 'Afficher Plus' : 'Afficher Moins';
      }
    });
  }

  /* ==========================================================================
     9. COUNTDOWN TIMER
     ========================================================================== */
  function initCountdownTimer() {
    let secs = 4 * 3600 + 47 * 60 + 23;
    setInterval(function() {
      secs--;
      if (secs < 0) secs = 12 * 3600;
      const h = String(Math.floor(secs / 3600)).padStart(2, '0');
      const m = String(Math.floor((secs % 3600) / 60)).padStart(2, '0');
      const s = String(secs % 60).padStart(2, '0');

      document.querySelectorAll('.countdown-timer-box-hrs .countdown-timer-value, #ly-timer-hrs').forEach(el => el.textContent = h);
      document.querySelectorAll('.countdown-timer-box-mins .countdown-timer-value, #ly-timer-mins').forEach(el => el.textContent = m);
      document.querySelectorAll('.countdown-timer-box-secs .countdown-timer-value, #ly-timer-secs').forEach(el => el.textContent = s);
    }, 1000);
  }

  /* ==========================================================================
     10. FOOTER NEWSLETTER
     ========================================================================== */
  function initFooterNewsletter() {
    document.addEventListener('submit', function(e) {
      if (e.target.matches('.lf-footer__form, #newsletter-form')) {
        e.preventDefault();
        const form = e.target;
        form.innerHTML = `
          <div style="background: #eaf6ef; color: #12412b; padding: 14px 20px; border-radius: 8px; font-size: 14px; font-weight: 600;">
            ✓ Thank you for subscribing! Check your inbox for 10% off.
          </div>
        `;
      }
    });
  }

  /* ==========================================================================
     11. STICKY BOTTOM BAR
     ========================================================================== */
  function initStickyCTA() {
    const buyBox = document.querySelector('.lw-pdp, #lymphoria-buy-box, #shopify-section-template--20177151033483__lymphoria_home_buy_box_wbz_RwVcQY');
    const sticky = document.getElementById('ly-sticky-bar');

    window.addEventListener('scroll', function() {
      if (!buyBox || !sticky) return;
      const rect = buyBox.getBoundingClientRect();
      if (rect.top < -100 && rect.bottom > 200) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }, { passive: true });
  }

  /* ==========================================================================
     12. SMOOTH SCROLL FOR HERO & CTAS
     ========================================================================== */
  function initSmoothScrolling() {
    document.addEventListener('click', function(e) {
      const anchor = e.target.closest('a[href="#lymphoria-buy-box"], .lw-faq__cta a, .hero__cta, .banner-cta, .ly-story-card__btn');
      if (anchor) {
        const target = document.querySelector('#lymphoria-buy-box, .lw-pdp, #shopify-section-template--20177151033483__lymphoria_home_buy_box_wbz_RwVcQY');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  }

  /* ==========================================================================
     13. INJECT REQUIRED HTML MODALS & CSS
     ========================================================================== */
  function injectModalsAndDrawers() {
    if (!document.querySelector('.custom_overlay')) {
      const o1 = document.createElement('div');
      o1.className = 'custom_overlay';
      document.body.appendChild(o1);
    }
    if (!document.querySelector('.custom_overlay2')) {
      const o2 = document.createElement('div');
      o2.className = 'custom_overlay2';
      document.body.appendChild(o2);
    }
    if (!document.getElementById('ly-sticky-bar')) {
      const stick = document.createElement('div');
      stick.id = 'ly-sticky-bar';
      stick.className = 'ly-sticky-floating-bar';
      const initialImg = document.querySelector('.lw-pdp__offer.is-active img, .lw-pdp__offer img, .swiper-slide img')?.src || 'https://cdn.shopify.com/s/files/1/0818/5210/4761/files/Frame_2147243848.png';
      stick.innerHTML = `
        <div class="ly-sticky-bar-inner">
          <div class="ly-sticky-product-meta">
            <img src="${initialImg}" class="ly-sticky-thumb" alt="Lympha Flow">
            <div>
              <div class="ly-sticky-title">Lympha Flow® Gouttes de Drainage</div>
              <div class="ly-sticky-sub"><span id="ly-sticky-tier-name">Achetez 2, Obtenez 1 GRATUIT</span> &bull; <strong id="ly-sticky-tier-price">€70,95</strong></div>
            </div>
          </div>
          <button type="button" class="ly-sticky-btn" id="ly-sticky-atc-btn">Ajouter au Panier &rarr;</button>
        </div>
      `;
      document.body.appendChild(stick);
    }

    const css = `
      @keyframes spin { 100% { transform: rotate(360deg); } }
      #cart-drawer {
        position: fixed;
        top: 0; right: -100%;
        width: 100%; max-width: 480px; height: 100vh;
        background: #ffffff;
        z-index: 99999;
        box-shadow: -10px 0 40px rgba(0,0,0,0.15);
        display: flex; flex-direction: column;
        transition: right 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
        overflow: hidden;
      }
      #cart-drawer.open { right: 0 !important; }
      .custom_overlay2, .custom_overlay {
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(18, 65, 43, 0.45);
        backdrop-filter: blur(4px);
        z-index: 99998;
        opacity: 0; visibility: hidden;
        transition: all 0.3s ease;
      }
      .custom_overlay2.active, .custom_overlay.active { opacity: 1; visibility: visible; }
      .cart_content_fill { display: flex; flex-direction: column; height: 100%; }
      .cart_heading_custom { padding: 18px 24px; border-bottom: 1px solid #edf2ee; display: flex; align-items: center; gap: 12px; }
      .cart_heading_title { font-family: 'Clash Grotesk', sans-serif; font-size: 18px; font-weight: 600; color: #12412b; }
      .cart_choice_badge { background: #eaf6ef; color: #12412b; font-size: 12px; font-weight: 600; padding: 3px 10px; border-radius: 12px; }
      .cart_free_shipping_box { background: #f4f9f6; padding: 12px 24px; border-bottom: 1px solid #e2ece5; }
      .cart_free_shipping_text { font-size: 13px; color: #12412b; margin-bottom: 6px; }
      .cart_free_shipping_bar { height: 5px; background: #d4e5db; border-radius: 3px; overflow: hidden; }
      .cart_free_shipping_fill { height: 100%; background: #47c08e; }
      .cart_middle_scroll { flex: 1; overflow-y: auto; padding: 20px 24px; }
      .cart_items_wrapper { display: flex; flex-direction: column; gap: 16px; margin-bottom: 16px; }
      .cart_item_single_flex { display: flex !important; align-items: center !important; gap: 12px !important; padding: 12px 14px !important; background: #ffffff !important; border: 1px solid #d0d0d0 !important; border-radius: 8px !important; position: relative !important; margin-bottom: 12px !important; }
      .cart_item_single_left { width: 68px !important; height: 68px !important; flex-shrink: 0 !important; border: 1px solid #b7dfca !important; border-radius: 6px !important; display: flex !important; align-items: center !important; justify-content: center !important; background: #fbfdfc !important; padding: 4px !important; }
      .cart_item_single_left img { width: 100% !important; height: 100% !important; object-fit: contain !important; }
      .cart_item_single_right { flex: 1 !important; display: flex !important; flex-direction: column !important; gap: 8px !important; min-width: 0 !important; }
      .cart_item_single_top_row { display: flex !important; justify-content: space-between !important; align-items: flex-start !important; gap: 8px !important; }
      .cart_item_single_title_wrap { flex: 1 !important; }
      .cart_item_single_title { font-size: 14px !important; font-weight: 600 !important; color: #12412b !important; margin: 0 !important; line-height: 1.3 !important; }
      .cart_item_single_variant_tag { font-size: 11px !important; color: #666666 !important; margin-top: 2px !important; }
      .cart_item_single_prices { text-align: right !important; white-space: nowrap !important; }
      .cart_item_single_price { font-size: 16px !important; font-weight: 700 !important; color: #154B32 !important; display: block !important; }
      .cart_item_single_price_compare { font-size: 12px !important; color: #888888 !important; text-decoration: line-through !important; }
      .cart_item_single_bottom_row { display: flex !important; justify-content: space-between !important; align-items: center !important; width: 100% !important; margin-top: 2px !important; }
      .cart_quantity_wrapper { display: inline-flex !important; align-items: center !important; border: 1px solid #d5d5d5 !important; border-radius: 4px !important; background: #ffffff !important; height: 30px !important; overflow: hidden !important; }
      .cart_quantity_button { background: #ffffff !important; border: none !important; width: 28px !important; height: 100% !important; font-size: 16px !important; font-weight: 600 !important; color: #154B32 !important; cursor: pointer !important; display: flex !important; align-items: center !important; justify-content: center !important; padding: 0 !important; }
      .cart_quantity_button.quantity_minus { border-right: 1px solid #e5e5e5 !important; }
      .cart_quantity_button.quantity_plus { border-left: 1px solid #e5e5e5 !important; }
      .fake_quantity_display { width: 32px !important; border: none !important; text-align: center !important; font-size: 14px !important; font-weight: 600 !important; color: #154B32 !important; padding: 0 !important; background: transparent !important; }
      .cart_item_single_right_remove { background: transparent !important; border: none !important; cursor: pointer !important; padding: 4px !important; display: flex !important; align-items: center !important; justify-content: center !important; color: #717171 !important; transition: color 0.2s ease, transform 0.15s ease !important; }
      .cart_item_single_right_remove:hover { color: #d9383a !important; transform: scale(1.1) !important; }
      .cart_item_single_right_remove svg { width: 20px !important; height: 20px !important; display: block !important; stroke: #717171 !important; }
      .cart_item_single_right_remove:hover svg { stroke: #d9383a !important; }
      .cart_reviews_section { border-top: 1px solid #eef3f0; padding-top: 18px; }
      .cart_reviews_title { font-family: 'Clash Grotesk', sans-serif; font-size: 15px; font-weight: 600; color: #12412b; margin-bottom: 10px; }
      .review_box_incart { background: #ffffff; border: 1px solid #e2ebe5; border-radius: 8px; padding: 14px; }
      .review_stars_incart { color: #e5a93b; font-size: 13px; margin-bottom: 4px; }
      .review_text_incart { font-size: 13px; line-height: 1.45; color: #4a5c53; font-style: italic; margin: 0 0 6px 0; }
      .review_author_incart { font-size: 12px; font-weight: 600; color: #12412b; }
      .verified_tag { color: #47c08e; font-weight: 500; }
      .cart_footer_custom { padding: 20px 24px; border-top: 1px solid #e2ebe5; background: #fafcfb; }
      .cart_footer_subtotal_flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
      .cart_subtotal_label { font-size: 16px; font-weight: 600; color: #12412b; }
      .cart_subtotal_values { display: flex; align-items: center; gap: 10px; }
      .cart_savings_pill { background: #faecea; color: #d94b38; font-size: 12px; font-weight: 700; padding: 3px 8px; border-radius: 12px; }
      .cart_subtotal_amount { font-family: 'Clash Grotesk', sans-serif; font-size: 20px; font-weight: 700; color: #12412b; }
      .checkout_button_custom { width: 100%; background: #12412b; color: #ffffff; border: none; padding: 16px; border-radius: 30px; font-family: 'Clash Grotesk', sans-serif; font-size: 15px; font-weight: 600; letter-spacing: 0.05em; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: background 0.3s ease; }
      .checkout_button_custom:hover { background: #1a5a3c; }
      .cart_trust_footer_row { display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 12px; color: #7b9487; margin-top: 12px; }
      .ly-login-modal { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -46%) scale(0.96); width: 90%; max-width: 440px; background: #ffffff; border-radius: 16px; padding: 36px 32px; z-index: 99999; box-shadow: 0 20px 50px rgba(18, 65, 43, 0.2); opacity: 0; visibility: hidden; transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); font-family: 'Inter', sans-serif; }
      .ly-login-modal.is-open { opacity: 1; visibility: visible; transform: translate(-50%, -50%) scale(1); }
      .ly-login-close { position: absolute; top: 18px; right: 18px; background: none; border: none; font-size: 24px; cursor: pointer; color: #12412b; }
      .ly-login-header { text-align: center; margin-bottom: 24px; }
      .ly-login-title { font-family: 'Clash Grotesk', sans-serif; font-size: 24px; font-weight: 600; color: #12412b; margin: 0 0 6px 0; }
      .ly-login-subtitle { font-size: 14px; color: #6d8076; margin: 0; }
      .ly-form-group { margin-bottom: 18px; }
      .ly-form-group label { display: block; font-size: 13px; font-weight: 600; color: #12412b; margin-bottom: 6px; }
      .ly-form-input { width: 100%; padding: 12px 16px; border: 1px solid #d4e0d8; border-radius: 8px; font-size: 14px; outline: none; box-sizing: border-box; }
      .ly-form-input:focus { border-color: #47c08e; }
      .ly-forgot-link { font-size: 12px; color: #47c08e; text-decoration: none; font-weight: 500; }
      .ly-login-submit-btn { width: 100%; background: #12412b; color: #ffffff; border: none; padding: 14px; border-radius: 30px; font-family: 'Clash Grotesk', sans-serif; font-size: 16px; font-weight: 600; cursor: pointer; margin-top: 8px; }
      .ly-login-submit-btn:hover { background: #1a5a3c; }
      .ly-login-footer { text-align: center; margin-top: 20px; font-size: 13px; color: #6d8076; }
      .ly-login-footer a { color: #12412b; font-weight: 600; text-decoration: underline; }
      .ly-sub-link { display: inline-block; margin-top: 8px; color: #47c08e !important; font-weight: 600; }
      .ly-sticky-floating-bar { position: fixed; bottom: 0; left: 0; right: 0; background: rgba(255,255,255,0.98); backdrop-filter: blur(8px); border-top: 1px solid #e8f0eb; padding: 12px 24px; z-index: 9999; transform: translateY(100%); transition: transform 0.3s ease; box-shadow: 0 -4px 20px rgba(0,0,0,0.06); }
      .ly-sticky-floating-bar.is-visible { transform: translateY(0); }
      .ly-sticky-bar-inner { max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; }
      .ly-sticky-product-meta { display: flex; align-items: center; gap: 12px; }
      .ly-sticky-thumb { width: 44px; height: 44px; object-fit: contain; background: #f8f4eb; border-radius: 6px; }
      .ly-sticky-title { font-family: 'Clash Grotesk', sans-serif; font-weight: 600; font-size: 14px; color: #12412b; }
      .ly-sticky-sub { font-size: 13px; color: #556c60; }
      .ly-sticky-btn { background: #12412b; color: #ffffff; border: none; padding: 12px 28px; border-radius: 24px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background 0.3s; }
      .ly-sticky-btn:hover { background: #1a5a3c; }
      .lw-pdp__offer[aria-pressed="true"], .lw-pdp__offer.is-selected, .lw-pdp__offer.is-active { border-color: #12412b !important; background-color: #e3f7e8 !important; }
      .lw-pdp__plan[aria-pressed="true"], .lw-pdp__plan.is-selected, .lw-pdp__plan.is-active { border-color: #12412b !important; }
      .overflow-hidden { overflow: hidden !important; }
    `;
    const st = document.createElement('style');
    st.innerHTML = css;
    document.head.appendChild(st);
  }

})();
